import styled from 'styled-components'

export const StyledLobby = styled.div`
  #game-stand {
    position: absolute;
    left: 2.5%;
    bottom: 9%;
  }
  #mte-stand {
    position: absolute;
    right: 4%;
    bottom: 9%;
  }
  #current-user {
    pointer-events: none;
    position: absolute;
    right: 5px;
    bottom: 5px;
    font-size: 10px;
    color: gray;
  }
  .trailer {
    position: absolute;
    top: 17.4%;
    left: 37%;
    right: 36.7%;
    bottom: 51%;
    img {
      width: 100%;
      /* height: 100%; */
    }
  }
`
